module.exports = __webpack_public_path__ + "c850cd2395af969e56e8a8d706bdac49.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/alipay.png
// module id = 644
// module chunks = 0